import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../../CustomPagination';
import Link from '../../../Link';
import Loader from '../../../../components/Common/Loader';

import messages from '../../../../locale/messages';
import history from '../../../../history';
import debounce from '../../../../helpers/debounce';
import { updatePricingStatus } from '../../../../actions/siteadmin/Pricing/updatePricingStatus';
import { deletePricing } from '../../../../actions/siteadmin/Pricing/deletePricing';
import getCurrentPage from '../../../../helpers/getCurrentPage';
import { demoRestriction } from '../../../../actions/demoRestriction';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../../components/commonStyle.css';
import s from './PricingList.css';
import st from './PricingStudio.css';
class PricingList extends React.Component {
  static defaultProps = {
    pricingDetails: {
      loading: true
    }
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchKeyword: '',
      statusFilter: 'all'
    };
  }

  handleClick = () => {
    history.push('/add')
  }

  handleKeywordSearch = debounce((searchKeyword) => {
    const { pricingDetails: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchKeyword
    }
    this.setState({ searchKeyword, currentPage: 1 });
    refetch(variables);
  });

  handleDelete = async (id, currentPage) => {
    const { deletePricing, pricingDetails: { refetch, getAllPricing }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({ restrictType: 'fare', restrictValue: id });
    if (isRestrict) return;
    currentPage = await getCurrentPage({ results: getAllPricing?.results, page: currentPage });
    let variables = { currentPage };
    const response = await deletePricing(id);
    if (response?.status == 200) {
      this.setState({ currentPage });
      refetch(variables);
    }
  }

  paginationData = (currentPage) => {
    const { pricingDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleStatus = async (e, id) => {
    const { updatePricingStatus, pricingDetails: { refetch }, demoRestriction } = this.props;
    let status = e.target.value == 'true' ? true : false;
    const isRestrict = await demoRestriction({ restrictType: 'fare', restrictValue: id });
    if (isRestrict) return;
    const updateActiveStatus = await updatePricingStatus(id, status);
    if (updateActiveStatus && updateActiveStatus.status === 200) {
      let variables = { currentPage: 1 };
      this.setState({ currentPage: 1 });
      refetch(variables);
    }
  }

  // Human-readable unit for the fare, based on the category pricing type.
  fareUnit = (item) => {
    const type = item.category && item.category.pricingType;
    if (type === 'hourly') return `/hr · min ${item.multiplierValue || 0}h`;
    return `· max qty ${item.multiplierValue || 0}`;
  }

  render() {
    const { pricingDetails, pricingDetails: { loading, getAllPricing }, loadingTable } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, statusFilter } = this.state;

    const allItems = getAllPricing?.results || [];
    const items = statusFilter === 'all'
      ? allItems
      : allItems.filter((it) => (statusFilter === 'active' ? it.isActive : !it.isActive));

    return (
      <div className={'whiteDropdown'}>
        <div className={st.toolbar}>
          <div className={st.filters}>
            <div className={cx(st.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
            </div>
            <select className={cx(bt.selectInput, st.filterSelect)} value={statusFilter} onChange={(e) => this.setState({ statusFilter: e.target.value })}>
              <option value="all">All statuses</option>
              <option value="active">{formatMessage(messages.active)}</option>
              <option value="inactive">{formatMessage(messages.inactive)}</option>
            </select>
          </div>
          <Link to={"/siteadmin/pricing/add"} className={cx(bt.btnPrimary, bt.displayInlineBlock)} >{formatMessage(messages.addFare)}</Link>
        </div>

        {loadingTable && <Loader type="circle" />}

        {!loadingTable && items.length === 0 && (
          <div className={st.empty}><FormattedMessage {...messages.noResult} /></div>
        )}

        {!loadingTable && items.length > 0 && (
          <ul className={st.list}>
            {items.map((item) => (
              <li key={item.id} className={st.row}>
                <div className={st.priceBlock}>
                  <span className={st.price}>{item.currency} {item.basePrice}</span>
                  <span className={st.priceUnit}>{this.fareUnit(item)}</span>
                </div>

                <div className={st.mainCol}>
                  <span className={st.subName}>{item.subCategory && item.subCategory.name}</span>
                  <span className={st.meta}>#{item.id} · 📍 {item.location && item.location.locationName}</span>
                </div>

                <span className={st.catBadge}>{item.category && item.category.name}</span>
                {item.isPriceEditable && <span className={st.editableBadge}>Pro can edit</span>}

                <select
                  value={item.isActive}
                  onChange={(e) => this.handleStatus(e, item.id)}
                  className={cx(bt.selectInput, st.statusSelect, item.isActive ? st.statusActive : st.statusInactive)}
                >
                  <option value={true}>{formatMessage(messages.active)}</option>
                  <option value={false}>{formatMessage(messages.inactive)}</option>
                </select>

                <div className={st.actions}>
                  <Link to={'/siteadmin/pricing/edit/' + item.id} className={st.actionLink} title={formatMessage(messages.editAction)}>
                    <CommonAdminEditIcon className={st.icon} />
                  </Link>
                  <button type="button" className={st.actionBtn} onClick={() => this.handleDelete(item.id, currentPage)} title={formatMessage(messages.deleteAction)}>
                    <CommonAdminTrashIcon className={st.icon} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
        {
          pricingDetails?.getAllPricing?.results && pricingDetails?.getAllPricing?.count > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={pricingDetails?.getAllPricing?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.fares)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapDispatch = {
  updatePricingStatus,
  deletePricing,
  demoRestriction
};

const mapState = (state) => ({
  loading: state?.intl?.loading
});

export default injectIntl(compose(
  withStyles(bt, s, st),
  connect(mapState, mapDispatch)
)(PricingList));
